import { createAsyncThunk } from '@reduxjs/toolkit';
import NEWAPI from '../../API/newIndex';

export const importProductUpdate = createAsyncThunk(
  'product/importProductUpdate',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await NEWAPI({
        url: `/admin/product/ImportProductUpdate`,
        method: 'POST',
        data: payload,
      });

      return res ?? null;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
